import baseService from "@common/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;

let http = baseService(store, tbRoute);

const apiDef = {
  getById(id) {
    return http.get(`/DecaSolicitacaoExterno/comprovante/${id}`);
  },
  imprimirComprovante(data) {
    return http.post(`/DecaSolicitacaoExterno/imprimirComprovante`, data);
  },
};

export default apiDef;
